"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _icons = _interopRequireDefault(require("../glyphs/24/icons-24.svg"));

var _IconSvgModule = _interopRequireDefault(require("./IconSvg.module.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var IconSvg = function IconSvg(_ref) {
  var name = _ref.name,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'sm' : _ref$size,
      bgImg = _ref.bgImg,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'inherit' : _ref$color,
      style = _ref.style,
      className = _ref.className,
      outline = _ref.outline;
  var type = {
    xs: {
      size: 18,
      path: "".concat(_icons["default"], "#").concat(name)
    },
    sm: {
      size: 24,
      path: "".concat(_icons["default"], "#").concat(name)
    },
    lg: {
      size: 96,
      path: "/assets/icons/96/".concat(name, ".svg")
    }
  };
  return name === 'none' ? /*#__PURE__*/_react["default"].createElement("svg", {
    className: (0, _clsx2["default"])(_IconSvgModule["default"].icon, _IconSvgModule["default"]["icon".concat(type[size].size)]),
    viewBox: "0 0 ".concat(type[size].size, " ").concat(type[size].size)
  }) : /*#__PURE__*/_react["default"].createElement("svg", {
    className: (0, _clsx2["default"])(_IconSvgModule["default"].icon, _IconSvgModule["default"]["icon".concat(type[size].size)], className, _defineProperty({}, _IconSvgModule["default"]['text-white icon-outline'], outline)),
    style: _objectSpread({}, style),
    viewBox: "0 0 24 24"
  }, bgImg && /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "/assets/icons/96/effects.svg#shape"
  }), /*#__PURE__*/_react["default"].createElement("use", {
    stroke: "inherit",
    xlinkHref: type[size].path
  }));
};

IconSvg.defaultProps = {
  name: 'none',
  bgImg: false
};
IconSvg.muiName = 'SvgIcon';
var _default = IconSvg;
exports["default"] = _default;